import {isNavigator} from './browser'

export const isPlaywright = () => isNavigator && !!navigator.webdriver
